export default __webpack_public_path__ + "static/people-8baf37831ccd0b04d5802f4cb0704d99.png";